import { render, staticRenderFns } from "./ConfigCreate.vue?vue&type=template&id=4c067bed&"
import script from "./ConfigCreate.vue?vue&type=script&lang=ts&"
export * from "./ConfigCreate.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./ConfigCreate.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports